import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Programs',
    href: '#programs'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-sep-black text-white border-b border-white/10" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="flex justify-between items-center h-[60px] md:h-20" data-id="element-150">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-151">
            <a href="#home" className="flex items-center gap-2" data-id="element-152">
              <img src="https://cdn.magicpatterns.com/uploads/1t5KrLSHk2kgV3QLTxB2A5/slater-elite.png" alt="S.E.P. Logo" className="h-10 w-10 md:h-12 md:w-12 object-contain" data-id="element-153" />
              <span className="font-heading font-bold text-lg md:text-xl tracking-tight hidden sm:block" data-id="element-154">
                SLATER ELITE
              </span>
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-155">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium hover:text-sep-red transition-colors" data-id="element-156">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-sep-red hover:bg-sep-red-dark text-white px-5 py-2 rounded-md font-bold text-sm transition-colors" data-id="element-157">
              BOOK NOW
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-158">
            <button onClick={() => setIsOpen(!isOpen)} className="text-white hover:text-sep-red focus:outline-none p-2" aria-label="Toggle menu" data-id="element-159">
              {isOpen ? <X size={24} data-id="element-160" /> : <Menu size={24} data-id="element-161" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-sep-black border-t border-white/10 absolute w-full" data-id="element-162">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 shadow-xl" data-id="element-163">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium hover:bg-white/5 hover:text-sep-red rounded-md transition-colors" onClick={() => setIsOpen(false)} data-id="element-164">
                {link.name}
              </a>)}
            <a href="#contact" className="block w-full text-center mt-4 bg-sep-red hover:bg-sep-red-dark text-white px-5 py-3 rounded-md font-bold text-base transition-colors" onClick={() => setIsOpen(false)} data-id="element-165">
              BOOK NOW
            </a>
          </div>
        </div>}
    </nav>;
}